'use client'
import Link from 'next/link'
import Image from 'next/image'

const resolveHref = (node) => {
  if (!node?.IsInternalURL) {
    return node?.ExternalURL?.trim() || '#'
  }

  if (!node?.LinkURL) return '#'

  const link = node.LinkURL.trim()
  const para = node.LinkURLPagePara?.trim() ?? ''

  // 首頁
  if (link === '/') return '/'

  // 判斷是否為「詳情頁」
  const isDetail =
    link.includes('Detail') ||
    link.includes('DetailPage') ||
    link.includes('Detail/') ||
    link.startsWith('/product/') // 商品詳情

  // 判斷是否為「列表頁」
  const isList =
    link.includes('List') ||
    link.includes('list') ||
    link.startsWith('/product-list')

  const isProductListCategory = link.startsWith('/product-list?categoryid=')
  const isProductListBrand = link.startsWith('/product-list?brandid=')
  const isMemberCenter = link.startsWith('/MemberCenter')

  let finalLink = ''

  if (isDetail) {
    // 詳情頁要加參數
    finalLink = link.endsWith('/') ? `${link}${para}` : `/${link}${para}`
  } else if (isList) {
    // 列表頁不加斜線、不加參數（除了 product-list 特例）
    if (isProductListCategory || isProductListBrand) {
      finalLink = `${link}${para}` // 保留參數
    } else {
      finalLink = link // 不加任何參數
    }
  } else if (isMemberCenter) {
    // 會員中心保持原樣
    finalLink = `${link}${para}`
  } else {
    // 其他一般頁面要加斜線，但不帶參數
    finalLink = link.startsWith('/') ? `${link}` : `/${link}`
  }

  // 防呆：移除多餘斜線
  finalLink = finalLink.replace(/\/{2,}/g, '/')

  return finalLink
}

export default function MobileCustomPictureNav({ activeMenu, selectors }) {
  if (!activeMenu || !activeMenu.Children?.length) return null

  const children = activeMenu.Children

  return (
    <div
      style={{
        padding: '16px',
        background: '#fff',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          gap: '16px',
        }}
      >
        {children.map((child) => (
          <Link
            key={child.MenuID}
            href={resolveHref(child)}
            style={{
              width: 'calc(50% - 8px)', // 每列固定兩張（100% - gap）
              background: '#fff',
              textAlign: 'center',
              padding: '12px',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClickCapture={() => {
              document.body.classList.remove(selectors.mobileMenuActiveClass)
            }}
          >
            {/* 固定比例圖片容器 */}
            <div
              style={{
                width: '100%',
                aspectRatio: '3/4',
                overflow: 'hidden',
                marginBottom: '8px',
                position: 'relative',
                flexShrink: 0,
              }}
            >
              <Image
                src={child.PicturePath}
                alt={child.MenuName}
                fill
                sizes="(max-width: 600px) 50vw, 25vw"
                style={{
                  objectFit: 'contain',
                  objectPosition: 'center',
                }}
              />
            </div>

            <h4
              style={{
                fontSize: '14px',
                fontWeight: '500',
                marginBottom: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {child.MenuName}
            </h4>
          </Link>
        ))}
      </div>
    </div>
  )
}
